var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.08879 7.26524C0.698267 7.65577 0.698267 8.28893 1.08879 8.67946L7.45275 15.0434C7.84328 15.4339 8.47644 15.4339 8.86697 15.0434C9.25749 14.6529 9.25749 14.0197 8.86697 13.6292L3.21011 7.97235L8.86697 2.3155C9.25749 1.92497 9.25749 1.29181 8.86697 0.901283C8.47644 0.510759 7.84328 0.510759 7.45275 0.901283L1.08879 7.26524ZM17.7959 6.97235L1.7959 6.97235V8.97235L17.7959 8.97235V6.97235Z",
    fill: "#2D2D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrowLeft.dd17a46c5666e205941a04080b392e20.svg";
export { ForwardRef as ReactComponent };